import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import MuiTextField, { StandardTextFieldProps } from '@material-ui/core/TextField';
import classnames from 'classnames';
import { get } from 'lodash';

const styles = () =>
  createStyles({
    inputSmall: {
      height: '35px !important',
    },
    rounded: {
      borderRadius: 5,
    },
    rootReadOnly: {
      border: 'none',
    },
  });

// extending classes here will make it required when using the Interface
export interface TextFieldProps extends Omit<StandardTextFieldProps, 'classes'> {
  size?: 'default' | 'small';
  rounded?: boolean;
}

interface TextFieldStyledProps extends TextFieldProps, WithStyles<typeof styles> {}

const TextField: React.FC<TextFieldStyledProps> = ({ classes, size = 'default', rounded, InputProps, ...rest }) => (
  <MuiTextField
    InputProps={{
      classes: {
        input: classnames({
          [classes.inputSmall]: size === 'small',
          [classes.rounded]: rounded,
        }),
        root: classnames({
          [classes.rounded]: rounded,
          [classes.rootReadOnly]: get(rest.inputProps, 'readOnly'),
        }),
      },
      ...InputProps,
      inputProps: {
        ...get(InputProps, 'inputProps', {}),
      },
    }}
    {...rest}
  />
);

export default withStyles(styles)(TextField);
